import map from 'lodash/map';
import * as actions from './actions';
import { GET_YEAR_GROUPS_SUCCESS } from '../school-roll/actions';
import * as studentRollActions from '../student-roll/actions';
import * as editStudentActions from '../edit-student/actions';
import * as teacherRollActions from '../teacher-roll/actions';
import * as editTeacherActions from '../edit-teacher/actions';
import * as assignUser from '../assign-user/actions';
import * as editClassActions from '../edit-class/actions';
import { filterProductCourses, updateYearGroups, updateTeachers } from '../../helpers/utils';
import { filterClasses, sort } from '../../helpers/grid-util';
import messages from './messages';

const dataFilterOption = {
    yearGroups: [{ key: '-1', value: messages.defaultOptionYearGroup, selected: true }],
    teachers: [{ key: '-1', value: messages.defaultOptionTeachers, selected: true }],
    searchTerm: '',
    sortColumn: 'name',
    sortDirection: 'asc'
};

const assignEmptyClassObject = () => (
    { name: '', yearGroup: '-1', countryId: '-1', courseId: '-1', teacherId: '-1', productId: '-1' }
);

const initState = {
    isClassroomDataLoaded: false,
    classrooms: [],
    yearGroups: [],
    productCourses: [],
    isProductCoursesLoaded: false,
    isProductCoursesFetching: false,
    isUPFCoursesFetching: false,
    isNewCoursesFetching: false,
    classModel: assignEmptyClassObject(),
    lastAddedClassId: 0,
    showAddClassModal: false,
    showAddClassConfirmationModal: false,
    selectedClasses: [],
    filteredClasses: [],
    operationType: '',
    isStudentsSignInCardDownloaded: true,
    refreshList: false,
    isClassRollDownloaded: true,
    deletingClassrooms: false,
    showDeleteClassroomsConfirmation: false,
    showDeleteClassroomsSuccess: false,
    deletingEmptyClassrooms: false,
    dataFilterOption,
    showHideSignInCardModal: false,
    upfCourses: [],
    newCourses: [],
    classAdded: '',
    deletedClassesCount: 0
};

const selectAllStudents = (students, checked) => {
    const studentList = map(students, (student) => {
        student.selected = checked;
        return student;
    });
    return studentList;
};

const getSortedData = (classrooms, filterOptions) => sort(
    classrooms,
    filterOptions.sortColumn,
    filterOptions.sortDirection);

const getFilteredData = (classrooms, filterOptions) => filterClasses(classrooms, filterOptions);

const resetSelectedItem = (items) => {
    const selectedItem = items.find(item => item.selected === true);
    selectedItem.selected = false;
    items[0].selected = true;
    return items;
};

const resetFilterOptions = (currentOptions) => {
    const yearGroups = resetSelectedItem(currentOptions.yearGroups);
    const teachers = resetSelectedItem(currentOptions.teachers);

    return { ...currentOptions, yearGroups, teachers, searchTerm: currentOptions.searchTerm };
};

const changeFilterOptions = (currentOptions, collectionName, key) => {
    const items = currentOptions[collectionName];
    const selectedItem = items.find(item => item.selected === true);
    selectedItem.selected = false;
    const newSelection = items.find(item => item.key.toString() === key);
    newSelection.selected = true;
    return { ...currentOptions, [collectionName]: currentOptions[collectionName] };
};

export default function (state = initState, action) {
    switch (action.type) {
    case actions.GET_CLASSROOMS_REQUEST: {
        return { ...state, isClassroomDataLoaded: action.isClassroomDataLoaded, deletedClassesCount: 0 };
    }
    case actions.GET_CLASSROOMS_SUCCESS: {
        return {
            ...state,
            classrooms: action.data,
            filteredClasses: action.data,
            isClassroomDataLoaded: action.isClassroomDataLoaded,
            refreshList: false
        };
    }
    case actions.GET_CLASSROOMS_FAILURE: {
        return { ...state, isClassroomDataLoaded: action.isClassroomDataLoaded };
    }

    case actions.DOWNLOAD_CLASS_ROLL_REQUEST: {
        return { ...state, isClassRollDownloaded: action.isClassRollDownloaded };
    }

    case actions.DOWNLOAD_CLASS_ROLL_SUCCESS: {
        return { ...state, isClassRollDownloaded: action.isClassRollDownloaded };
    }

    case actions.DOWNLOAD_CLASS_ROLL_FAILURE: {
        return { ...state, isClassRollDownloaded: action.isClassRollDownloaded };
    }

    case actions.PRINT_STUDENTS_SIGN_IN_CARD_REQUEST:
        return { ...state, isStudentsSignInCardDownloaded: action.isStudentsSignInCardDownloaded };

    case actions.PRINT_STUDENTS_SIGN_IN_CARD_SUCCESS :
    {
        window.location.href = action.downloadUrl;
        return { ...state, isStudentsSignInCardDownloaded: action.isStudentsSignInCardDownloaded };
    }

    case actions.PRINT_STUDENTS_SIGN_IN_CARD_FAILURE : {
        return { ...state, isStudentsSignInCardDownloaded: action.isStudentsSignInCardDownloaded };
    }

    case GET_YEAR_GROUPS_SUCCESS: {
        return { ...state, dataFilterOption: updateYearGroups(state.dataFilterOption, action.data) };
    }

    case teacherRollActions.GET_PRODUCT_TEACHERS_SUCCESS: {
        return { ...state, dataFilterOption: updateTeachers(state.dataFilterOption, action.data) };
    }

    case actions.RETRIEVE_SELECTED_CLASSES: {
        return { ...state, selectedClasses: action.selectedClasses };
    }

    case actions.SORT_CLASS_LIST: {
        let sortDirection = 'asc';
        if (state.dataFilterOption.sortColumn === action.columnToSort) {
            if (state.dataFilterOption.sortDirection === 'asc') {
                sortDirection = 'desc';
            }
        }
        const filterOption = { ...state.dataFilterOption, sortColumn: action.columnToSort, sortDirection };
        const filteredClasses = getSortedData(state.filteredClasses, filterOption);
        return { ...state, filteredClasses, dataFilterOption: filterOption };
    }
    case actions.CLASS_UPDATE_SEARCH_TERM: {
        const filterOption = { ...state.dataFilterOption, searchTerm: action.searchTerm };
        const filteredClasses = getFilteredData(state.classrooms, filterOption);
        return { ...state, filteredClasses, dataFilterOption: filterOption };
    }
    case actions.ADD_CLASS_OPEN_MODAL_REQUEST: {
        return {
            ...state,
            showAddClassModal: action.showAddClassModal,
            classModel: assignEmptyClassObject(),
            showAddClassConfirmationModal: action.showAddClassConfirmationModal,
            lastAddedClassId: 0
        };
    }

    case actions.ADD_CLASS_CLOSE_MODAL_REQUEST: {
        return {
            ...state,
            showAddClassModal: action.showAddClassModal,
            classModel: assignEmptyClassObject(),
            showAddClassConfirmationModal: action.showAddClassConfirmationModal,
            lastAddedClassId: 0,
            productCourses: [],
            refreshList: false
        };
    }

    case actions.GET_PRODUCT_COURSES_REQUEST: {
        return { ...state,
            productCourses: [],
            classModel: { ...state.classModel, courseId: '-1' },
            isProductCoursesLoaded: action.isProductCoursesLoaded,
            isProductCoursesFetching: action.isProductCoursesFetching };
    }

    case actions.GET_PRODUCT_COURSES_SUCCESS: {
        return { ...state,
            productCourses: filterProductCourses(action.data),
            classModel: { ...state.classModel, courseId: '-1' },
            isProductCoursesLoaded: action.isProductCoursesLoaded,
            isProductCoursesFetching: action.isProductCoursesFetching };
    }

    case actions.GET_PRODUCT_COURSES_FAILURE: {
        return { ...state,
            isProductCoursesLoaded: action.isProductCoursesLoaded,
            isProductCoursesFetching: action.isProductCoursesFetching };
    }

    case actions.ADD_CLASS_REQUEST: {
        return { ...state, isSaveInProgress: true, classAdded: action.ClassModel.name };
    }

    case actions.ADD_CLASS_SUCCESS: {
        return {
            ...state,
            isSaveInProgress: false,
            showAddClassConfirmationModal: false,
            showAddClassModal: false,
            refreshList: true,
            selectedClasses: [],
            dataFilterOption: resetFilterOptions(state.dataFilterOption)
        };
    }

    case actions.ADD_CLASS_FAILURE: {
        return {
            ...state,
            isSaveInProgress: false,
            showAddClassModal: true,
            showAddClassValidationModal: action.showAddClassValidationModal,
            addClassValidationMessage: action.errorMessage
        };
    }

    case actions.CLOSE_ADD_CLASS_VALIDATION_MODAL: {
        return {
            ...state,
            showAddClassValidationModal: action.showAddClassValidationModal
        };
    }

    case actions.CLASS_FILTER_VALUE_CLEARED: {
        if (state.dataFilterOption.sortDirection === 'desc') {
            state.dataFilterOption.sortDirection = 'asc';
        }
        const filterOption = resetFilterOptions(state.dataFilterOption);
        const filteredClasses = getFilteredData(state.classrooms, filterOption);
        return { ...state, filteredClasses, dataFilterOption: filterOption, selectedClasses: [] };
    }
    case actions.CLASS_FILTER_VALUE_CHANGED: {
        const filterOption = changeFilterOptions(state.dataFilterOption, action.collectionName, action.key);
        const filteredClasses = getFilteredData(state.classrooms, filterOption);
        return { ...state, filteredClasses, dataFilterOption: filterOption, selectedClasses: [] };
    }
    case actions.REFRESH_CLASS_LIST: {
        return { ...state, refreshList: false };
    }
    case assignUser.ASSIGN_STUDENT_SUCCESS:
    case assignUser.ASSIGN_TEACHER_SUCCESS:
    case assignUser.ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS:
    case editStudentActions.UNASSIGN_STUDENTS_USING_CLASSID_SUCCESS:
    case editTeacherActions.EDIT_TEACHER_SUCCESS_REQUEST:
    case editTeacherActions.UNASSIGN_TEACHERS_USING_CLASSID_SUCCESS:
    case studentRollActions.UNASSIGN_STUDENTS_SUCCESS:
    case studentRollActions.DELETE_STUDENT_SUCCESS:
    case studentRollActions.ADD_STUDENT_SUCCESS:
    case teacherRollActions.ADD_TEACHER_SUCCESS:
    case teacherRollActions.UNASSIGN_TEACHERS_SUCCESS:
    case teacherRollActions.DELETE_TEACHER_SUCCESS:
    case editClassActions.CHANGE_COURSE_SUCCESS:
    case editClassActions.DELETE_GROUP_SUCCESS:
    case editClassActions.ADD_GROUP_SUCCESS:
    case editClassActions.MODIFIED_CLASS_SAVE_SUCCESS:
    case editClassActions.CLOSE_EDIT_CLASS:
    {
        return { ...state, isClassroomDataLoaded: false, dataFilterOption: resetFilterOptions(state.dataFilterOption) };
    }

    case actions.GET_SCHOOL_COURSES_REQUEST: {
        return { ...state,
            productCourses: [],
            classModel: { ...state.classModel, courseId: '-1' },
            isSchoolCoursesLoaded: false,
            isSchoolCoursesFetching: true };
    }

    case actions.GET_SCHOOL_COURSES_SUCCESS: {
        return { ...state,
            productCourses: filterProductCourses(action.data),
            classModel: { ...state.classModel, courseId: '-1' },
            isSchoolCoursesLoaded: true,
            isSchoolCoursesFetching: false };
    }

    case actions.GET_SCHOOL_COURSES_FAILURE: {
        return { ...state,
            isSchoolCoursesLoaded: false,
            isSchoolCoursesFetching: false };
    }

    case actions.DELETE_CLASSROOMS_REQUEST: {
        return {
            ...state,
            deletingClassrooms: action.deletingClassrooms,
            refreshList: action.refreshList
        };
    }
    case actions.DELETE_CLASSROOMS_SUCCESS:
    case actions.DELETE_CLASSROOMS_FAILURE: {
        return {
            ...state,
            deletingClassrooms: action.deletingClassrooms
        };
    }

    case actions.CLOSE_DELETE_CLASSROOMS_CONFIRMATION: {
        return {
            ...state,
            showDeleteClassroomsConfirmation: action.showDeleteClassroomsConfirmation,
            deletingEmptyClassrooms: action.deletingEmptyClassrooms,
            selectedClasses: action.deletingEmptyClassrooms ? [...state.selectedClasses] : []
        };
    }
    case actions.SHOW_DELETE_CLASSROOMS_CONFIRMATION: {
        return {
            ...state,
            showDeleteClassroomsConfirmation: action.showDeleteClassroomsConfirmation,
            deletingEmptyClassrooms: action.deletingEmptyClassrooms
        };
    }
    case actions.SHOW_DELETE_CLASSROOMS_SUCCESS: {
        return {
            ...state,
            showDeleteClassroomsSuccess: action.showDeleteClassroomsSuccess

        };
    }
    case actions.CLOSE_DELETE_CLASSROOMS_SUCCESS: {
        const filterOption = resetFilterOptions(state.dataFilterOption);
        filterOption.searchTerm = '';
        return {
            ...state,
            showDeleteClassroomsSuccess: action.showDeleteClassroomsSuccess,
            selectedClasses: [],
            refreshList: action.refreshList,
            dataFilterOption: filterOption,
            deletedClassesCount: action.deletedClassesCount,
            deletingEmptyClassrooms: false
        };
    }
    case actions.GET_STUDENTS_BY_CLASSROOM_REQUEST: {
        return {
            ...state,
            isClassroomStudentsLoaded: action.isStudentDataLoaded
        };
    }

    case actions.GET_STUDENTS_BY_CLASSROOM_SUCCESS: {
        return {
            ...state,
            isClassroomStudentsLoaded: action.isStudentDataLoaded,
            assignedStudents: selectAllStudents(action.students, false)
        };
    }

    case actions.GET_STUDENTS_BY_CLASSROOM_FAILURE: {
        return {
            ...state,
            isClassroomStudentsLoaded: action.isStudentDataLoaded
        };
    }

    case actions.SHOW_HIDE_SIGNIN_CARD_MODAL: {
        return { ...state, showHideSignInCardModal: action.showHideSignInCardModal };
    }

    case actions.GET_UPF_COURSES: {
        return {
            ...state,
            isUPFCoursesFetching: action.isUPFCoursesFetching
        };
    }

    case actions.GET_UPF_COURSES_SUCCESS: {
        return {
            ...state,
            upfCourses: action.data,
            isUPFCoursesFetching: false
        };
    }

    case actions.GET_UPF_COURSES_FAILURE:
    case actions.CLEAR_UPF_COURSES: {
        return {
            ...state,
            upfCourses: [],
            isUPFCoursesFetching: false
        };
    }

    case actions.GET_NEW_COURSES_REQUEST: {
        return {
            ...state,
            isNewCoursesFetching: action.isNewCoursesFetching
        };
    }

    case actions.GET_NEW_COURSES_SUCCESS: {
        return {
            ...state,
            newCourses: action.data,
            isNewCoursesFetching: false
        };
    }

    case actions.GET_NEW_COURSES_FAILURE: {
        return {
            ...state,
            newCourses: [],
            isNewCoursesFetching: false
        };
    }

    case actions.CLEAR_PRODUCT_COURSES: {
        return {
            ...state,
            productCourses: []
        };
    }

    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/class-roll/reducer.js